import { render, staticRenderFns } from "./BackhaulCustomer.vue?vue&type=template&id=69146090"
import script from "./BackhaulCustomer.vue?vue&type=script&lang=js"
export * from "./BackhaulCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports